var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.shellComponent,{attrs:{"preview-settings":_setup.previewSettings,"shell-settings":_setup.shellSettings},scopedSlots:_vm._u([{key:"iFrameContent",fn:function(){return [_c(_setup.RenderIFrameContent,{attrs:{"creative-data":_vm.creative,"is-dragging":false}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }